export default function initM22() {
    //$(window).resize(function(){
      const $ = jQuery
        $(document).ready(function () {
            if ($(window).width() <= 991) {
               var li_width = 0;
               $('.tab-outer-wrap .resp-tabs-list li').each(function() {
                  li_width += $(this).outerWidth();
               });
               $(".tab-outer-wrap .resp-tabs-list").width(li_width);
            }


            $('#verticalTab').easyResponsiveTabs({
               type: 'vertical',
               width: 'auto',
               fit: true
            });


         });
         //});

         Fancybox.bind('[data-fancybox]', {});   

     $(document).on('click', '.scroll-trigger', function (e) {
    e.preventDefault(); // Prevent default action if necessary
    $('html, body').animate({
        scrollTop: $('.tab-outer-wrap').offset().top
    }, 1000); // 1000ms animation (1 second)
});

}